import { render, staticRenderFns } from "./Wp_jd_home_simple.vue?vue&type=template&id=b4d46596&scoped=true&"
import script from "./Wp_jd_home_simple.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_home_simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d46596",
  null
  
)

export default component.exports